// import React, { Component } from "react";
// import { NavLink, useParams } from "react-router-dom";
// import VideoImg from "assets/images/images_new/user-img.png";
// import ArrowIcon from "assets/images/images_new/dropdown-icon.svg";
// import TagIcon1 from "assets/images/images_new/tag1.svg";
// import TagIcon2 from "assets/images/images_new/tag2.svg";
// import TagIcon3 from "assets/images/images_new/tag3.svg";
// import TagIconDefault from "assets/images/images_new/tagDefault.png";
// import LoggingSystemImg from "assets/images/images_new/logging-system.png";
// import BoldICon from "assets/images/images_new/bold-icon.svg";
// import ArrowIcon1 from "assets/images/images_new/arrow-icon.svg";
// import SearchIcon from "assets/images/images_new/zoom-lens.png";

// // reactstrap components
// import {
//   Card,
//   CardBody,
//   CardHeader,
//   CardTitle,
//   Table,
//   Row,
//   Col,
//   Button,
//   Input,
//   FormGroup,
//   InputGroup,
//   InputGroupAddon,
//   NavLink as NavLink1,
//   TabContent,
//   TabPane,
//   Nav,
//   NavItem,
//   CardText,
//   InputGroupText,
// } from "reactstrap";
// import DataTable from "react-data-table-component";
// import API from "api.js";
// import ChromeCheck from "views/ChromeCheckGlobal.jsx";
// // core components
// import PanelHeader from "components/PanelHeader/PanelHeader.jsx";

// import { thead, tbody } from "variables/general";
// // import SortByExplanationVideo from "components/PracticeMaterial/SortByExplanationVideo";
// import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";

// // New components.
// import Filters from "components/PracticeMaterial/New/Filters";
// import SearchFilter from "components/PracticeMaterial/New/Filters/SearchFilter";
// import TypeFilters from "components/PracticeMaterial/New/Filters/TypeFilters";
// import OtherFilters from "components/PracticeMaterial/New/Filters/OtherFilters";
// import ListTable from "components/PracticeMaterial/New/ListTable";
// import QuestionListPagination from "components/PracticeMaterial/New/QuestionListPagination";
// import SubcategoryTitle from "Datasets/SubcategoryTitle.json";

// const ALL = 1;
// const MONTHLY_PREDICTIONS = 2;
// const EXAM_QUESTIONS = 3;

// class QuestionList extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       data: [],
//       total: 0,
//       page: 1,
//       search: "",
//       count: 10,
//       mark: "all",
//       attempted: "all",
//       activeTab: ALL,
//       type: this.props.params?.id || 0,
//       prediction: this.props.params?.type || 0,
//       all_ok: true,
//       orderby: "desc",
//       complexity: "all",
//       filterByVid: "all",
//       displaying_items: 10,
//       isLoading: false,
//     };
//   }

//   // componentWillUnmount() {
//   //   document.body.classList.remove("leftSidebarClosed");
//   // }

//   componentDidMount() {
//     // Add this on priority
//     // document.body.classList.add("leftSidebarClosed");

//     // load data
//     this.getListApi(1);
//   }

//   changePagination = (p) => {
//     let page = this.state.page + p;
//     if (page > 0 && page * 10 - 10 < this.state.total) {
//       this.setState({ page: page });
//       this.getListApi(page);
//     }
//   };

//   toggle = (tab) => {
//     if (this.state.activeTab !== tab) {
//       this.setState({ activeTab: tab, page: 1 }, () => {
//         this.getListApi(1);
//       });
//     }
//   };

//   getListApi = (page) => {
//     let {
//       type,
//       prediction,
//       search,
//       count,
//       activeTab,
//       mark,
//       attempted,
//       complexity,
//       orderby,
//       filterByVid,
//     } = this.state;
//     this.setState({ isLoading: true });
//     API({
//       method: "GET",
//       url: `question/${type}?prediction=${prediction}&page=${page}&search=${search}&count=${count}&type=${activeTab}&mark=${mark}&attempted=${attempted}&complexity=${complexity}&orderby=${orderby}&list=1&practice=true&filterByVid=${filterByVid}`,
//     })
//       .then((data) => {
//         this.setState({
//           data: data.data.data,
//           total: data.data.total,
//           isLoading: false,
//         });
//         localStorage.setItem("orderby", this.state.orderby);
//       })
//       .catch(() => {});
//   };

//   changeFilter = (key, value) => {
//     this.setState(
//       {
//         [key]: value,
//       },
//       () => {
//         // load respective data.
//         this.loadRespectiveData(key);
//       }
//     );
//   };

//   loadRespectiveData = (key) => {
//     if (
//       key === "orderby" ||
//       key === "complexity" ||
//       key === "attempted" ||
//       key === "mark" ||
//       key === "filterByVid"
//     ) {
//       this.getListApi(1);
//     }
//   };

//   clickSearch = () => {
//     this.getListApi(1);
//   };

//   handleSearchChange = (e) => {
//     const { value } = e.target;
//     this.setState({
//       search: value,
//     });
//   };

//   /**
//    * Update display items per page. in table.
//    */
//   updateListingItems = (items, page) => {
//     this.setState(
//       {
//         count: items,
//         page: page,
//       },
//       () => {
//         // run api again to get updated listing.
//         this.getListApi(page);
//       }
//     );
//   };

//   /**
//    * Change Pagination.
//    */
//   paginationChange = (page) => {
//     this.setState(
//       {
//         page,
//       },
//       () => {
//         this.getListApi(page);
//       }
//     );
//   };

//   /**
//    * Switch between tabs.
//    * All, Monthly Predictions, Exam Questions.
//    */
//   showData = (tab) => {
//     this.setState(
//       {
//         activeTab: tab,
//         page: 1,
//       },
//       () => {
//         this.getListApi(1);
//       }
//     );
//   };

//   /**
//    * Search by ExplanationVid.
//    */
//   searchByExplanationVideo = (e, val) => {
//     console.log(val);
//   };

//   render() {
//     let {
//       page,
//       count,
//       all_ok,
//       activeTab,
//       type,
//       mark,
//       attempted,
//       complexity,
//       search,
//       filterByVid,
//       orderby,
//     } = this.state;
//     let i = page * count - count;
//     const title = SubcategoryTitle[parseInt(type)];
//     console.log("The params>>>>>>>>>>>>", type);

//     console.log("Question List");

//     return (
//       <>
//         {!all_ok && <ChromeCheck />}
//         {all_ok && (
//           <div className="siteContent readAloudPage p-0">
//             <DashboardHeader title="Practice Material" />
//             <div className="dashboard-content-wrapper read-aloud-wrapper qlist-header">
//               <Card>
//                 <CardHeader className="p-0 w-100">
//                   <div className="read-aloud-header w-100">
//                     {/* Filters on left side. */}
//                     <div className="header-col-1">
//                       <div className="header-col-content">
//                         <CardTitle tag="h4">{title}</CardTitle>
//                         {/* type filters */}
//                         <TypeFilters
//                           ALL={ALL}
//                           MONTHLY_PREDICTIONS={MONTHLY_PREDICTIONS}
//                           EXAM_QUESTIONS={EXAM_QUESTIONS}
//                           activeTab={activeTab}
//                           showData={this.showData}
//                         />
//                       </div>

//                       {/* search bar filter */}
//                       <SearchFilter
//                         search={search}
//                         handleSearchChange={this.handleSearchChange}
//                         clickSearch={this.clickSearch}
//                       />
//                     </div>

//                     {/* Filters on right side. */}
//                     <div className="header-col-2">
//                       <OtherFilters
//                         orderby={orderby}
//                         complexity={complexity}
//                         attempted={attempted}
//                         mark={mark}
//                         filterByVid={filterByVid}
//                         changeFilter={this.changeFilter}
//                         type={parseInt(this.state.type)}
//                       />
//                     </div>
//                     {/* <Filters
//                         ALL={ALL}
//                         MONTHLY_PREDICTIONS={MONTHLY_PREDICTIONS}
//                         EXAM_QUESTIONS={EXAM_QUESTIONS}
//                         showData={this.showData}
//                         activeTab={activeTab}
//                         search={search}
//                         handleSearchChange={this.handleSearchChange}
//                         clickSearch={this.clickSearch}
//                         type={parseInt(this.state.type)}
//                         filterByVid={filterByVid}
//                         searchByExplanationVideo={this.searchByExplanationVideo}
//                       /> */}
//                   </div>
//                 </CardHeader>
//                 <CardBody>
//                   <div className="tab-content" id="myTabContent">
//                     <div
//                       className="tab-pane fade show active"
//                       id="all"
//                       role="tabpanel"
//                       aria-labelledby="all-tab"
//                     >
//                       <div className="table-responsive">
//                         {!this.state.isLoading && !this.state.data.length ? (
//                           <div className=".search-bar.no-result-message text-center py-4">
//                             <h4>No result found</h4>
//                           </div>
//                         ) : (
//                           <ListTable
//                             data={this.state.data}
//                             type={parseInt(this.state.type)}
//                             activeTab={activeTab}
//                             mark={mark}
//                             attempted={attempted}
//                             complexity={complexity}
//                             filterByVid={filterByVid}
//                             search={search}
//                             page={page}
//                             listing={this.state.displaying_items}
//                           />
//                         )}
//                       </div>
//                     </div>
//                     <div
//                       className="tab-pane fade"
//                       id="monthlyprediction"
//                       role="tabpanel"
//                       aria-labelledby="monthlyprediction-tab"
//                     >
//                       Monthly Prediction table
//                     </div>
//                     <div
//                       className="tab-pane fade"
//                       id="examquestions"
//                       role="tabpanel"
//                       aria-labelledby="examquestions-tab"
//                     >
//                       Exam Question Table
//                     </div>
//                   </div>

//                   {/* Pagination */}
//                   <QuestionListPagination
//                     total={this.state.total}
//                     listing={this.state.displaying_items}
//                     updateListingItems={this.updateListingItems}
//                     page={page}
//                     paginationChange={this.paginationChange}
//                   />
//                 </CardBody>
//               </Card>
//             </div>
//           </div>
//         )}
//       </>
//     );
//   }
// }

// // Wrapper component to handle React Router v6 params
// const QuestionListWrapper = () => {
//   const params = useParams();
//   return <QuestionList params={params} />;
// };

// export default QuestionListWrapper;

import React, { useState, useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import VideoImg from "assets/images/images_new/user-img.png";
import ArrowIcon from "assets/images/images_new/dropdown-icon.svg";
import TagIcon1 from "assets/images/images_new/tag1.svg";
import TagIcon2 from "assets/images/images_new/tag2.svg";
import TagIcon3 from "assets/images/images_new/tag3.svg";
import TagIconDefault from "assets/images/images_new/tagDefault.png";
import LoggingSystemImg from "assets/images/images_new/logging-system.png";
import BoldICon from "assets/images/images_new/bold-icon.svg";
import ArrowIcon1 from "assets/images/images_new/arrow-icon.svg";
import SearchIcon from "assets/images/images_new/zoom-lens.png";

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
  Input,
  FormGroup,
  InputGroup,
  NavLink as NavLink1,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  CardText,
  InputGroupText,
} from "reactstrap";
import DataTable from "react-data-table-component";
import API from "api.js";
import ChromeCheck from "views/ChromeCheckGlobal.jsx";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";

// import { thead, tbody } from "variables/general";
// import SortByExplanationVideo from "components/PracticeMaterial/SortByExplanationVideo";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";

// New components.
import Filters from "components/PracticeMaterial/New/Filters";
import SearchFilter from "components/PracticeMaterial/New/Filters/SearchFilter";
import TypeFilters from "components/PracticeMaterial/New/Filters/TypeFilters";
import OtherFilters from "components/PracticeMaterial/New/Filters/OtherFilters";
import ListTable from "components/PracticeMaterial/New/ListTable";
import QuestionListPagination from "components/PracticeMaterial/New/QuestionListPagination";
import SubcategoryTitle from "Datasets/SubcategoryTitle.json";
import Spinner from "components/Loader/Spinner";
import EmptyData from "components/EmptyData/EmptyData";

const ALL = 1;
const MONTHLY_PREDICTIONS = 2;
const EXAM_QUESTIONS = 3;

const QuestionList = () => {
  const params = useParams();
  const [tableRendered, setTableRendered] = useState(false);
  const [state, setState] = useState({
    data: [],
    total: 0,
    page: 1,
    search: "",
    count: 10,
    mark: "all",
    attempted: "all",
    activeTab: ALL,
    type: params?.id || 0,
    prediction: params?.type || 0,
    all_ok: true,
    orderby: "desc",
    complexity: "all",
    filterByVid: "all",
    displaying_items: 10,
    isLoading: false,
  });

  // componentWillUnmount equivalent
  // useEffect(() => {
  //   return () => {
  //     document.body.classList.remove("leftSidebarClosed");
  //   };
  // }, []);

  // componentDidMount equivalent
  useEffect(() => {
    // Add this on priority
    // document.body.classList.add("leftSidebarClosed");

    // load data
    getListApi(1);
  }, []);

  useEffect(() => {
    getListApi(1, state.count, state);
  }, [
    // state.count,
    state.complexity,
    state.orderby,
    state.attempted,
    state.mark,
    state.filterByVid,
  ]);

  // const changePagination = (p) => {
  //   let page = state.page + p;
  //   if (page > 0 && page * 10 - 10 < state.total) {
  //     setState(prev => ({ ...prev, page: page }));
  //     getListApi(page);
  //   }
  // };

  // const toggle = (tab) => {
  //   if (state.activeTab !== tab) {
  //     setState(prev => ({ ...prev, activeTab: tab, page: 1 }));
  //     getListApi(1);
  //   }
  // };

  // const getListApi = (page, newCount = state.count) => {
  //   let {
  //     type,
  //     prediction,
  //     search,
  //     // count,
  //     activeTab,
  //     mark,
  //     attempted,
  //     complexity,
  //     orderby,
  //     filterByVid,
  //   } = state;
  //   console.log("activeTab", activeTab);
  //   setState((prev) => ({ ...prev, isLoading: true }));
  //   API({
  //     method: "GET",
  //     url: `question/${type}?prediction=${prediction}&page=${page}&search=${search}&count=${newCount}&type=${activeTab}&mark=${mark}&attempted=${attempted}&complexity=${complexity}&orderby=${orderby}&list=1&practice=true&filterByVid=${filterByVid}`,
  //   })
  //     .then((data) => {
  //       setState((prev) => ({
  //         ...prev,
  //         data: data.data.data,
  //         total: data.data.total,
  //         isLoading: false,
  //       }));
  //       localStorage.setItem("orderby", state.orderby);
  //     })
  //     .catch(() => {});
  // };

  const getListApi = (page, newCount = state.count, override = {}) => {
    const {
      type,
      prediction,
      search,
      activeTab,
      mark,
      attempted,
      complexity,
      orderby,
      filterByVid,
    } = { ...state, ...override };

    setState((prev) => ({ ...prev, isLoading: true }));
    setTableRendered(false);
    API({
      method: "GET",
      url: `question/${type}?prediction=${prediction}&page=${page}&search=${search}&count=${newCount}&type=${activeTab}&mark=${mark}&attempted=${attempted}&complexity=${complexity}&orderby=${orderby}&list=1&practice=true&filterByVid=${filterByVid}`,
    }).then((data) => {
      setState((prev) => ({
        ...prev,
        data: data.data.data,
        total: data.data.total,
        isLoading: false,
      }));
      localStorage.setItem("orderby", state.orderby);
    });
  };

  const changeFilter = (key, value) => {
    setState((prev) => ({
      ...prev,
      [key]: value,
      page: 1,
    }));
    // load respective data.
    // loadRespectiveData(key);
  };

  const clearFilters = () => {
    changeFilter("orderby", "desc");
    changeFilter("complexity", "all");
    changeFilter("attempted", "all");
    changeFilter("mark", "all");
    changeFilter("filterByVid", "all");

    handleSearchChange({ target: { value: "" } });
  };

  // const loadRespectiveData = (key) => {
  //   if (
  //     key === "orderby" ||
  //     key === "complexity" ||
  //     key === "attempted" ||
  //     key === "mark" ||
  //     key === "filterByVid"
  //   ) {
  //     getListApi(1);
  //   }
  // };

  const clickSearch = () => {
    getListApi(1);
  };

  useEffect(() => {
    if (state.search === "") {
      getListApi(1);
    }
  }, [state.search]);

  const handleSearchChange = (e) => {
    const { value } = e.target;
    setState((prev) => ({
      ...prev,
      search: value,
      page: 1,
    }));
  };

  /**
   * Update display items per page. in table.
   */
  const updateListingItems = (items, page) => {
    setState((prev) => ({
      ...prev,
      count: items,
      page: page,
    }));
    // run api again to get updated listing.
    getListApi(page, items);
  };

  /**
   * Change Pagination.
   */
  const paginationChange = (page) => {
    setState((prev) => ({
      ...prev,
      page,
    }));
    getListApi(page, state.count);
  };

  /**
   * Switch between tabs.
   * All, Monthly Predictions, Exam Questions.
   */
  // const showData = (tab) => {
  //   console.log("tab", tab);
  //   setState((prev) => ({
  //     ...prev,
  //     activeTab: tab,
  //     page: 1,
  //   }));
  //   getListApi(1);
  // };

  const showData = (tab) => {
    setState((prev) => ({
      ...prev,
      activeTab: tab,
      page: 1,
    }));

    getListApi(1, state.count, { activeTab: tab });
  };

  /**
   * Search by ExplanationVid.
   */
  // const searchByExplanationVideo = (e, val) => {
  //   console.log(val);
  // };

  let {
    page,
    count,
    all_ok,
    activeTab,
    type,
    mark,
    attempted,
    complexity,
    search,
    filterByVid,
    orderby,
  } = state;
  let i = page * count - count;
  const titleIndexOverride = { 18: 17, 19: 18, 20: 19 };
  const typeInt = parseInt(type);
  const title = SubcategoryTitle[titleIndexOverride[typeInt] ?? typeInt];
  
  console.log("question list");
  

  return (
    <>
      {!all_ok && <ChromeCheck />}
      {all_ok && (
        <div className="siteContent readAloudPage p-0">
          <DashboardHeader title="Practice Material" />
          <div className="dashboard-content-wrapper read-aloud-wrapper qlist-header table-scrolling">
            <Card className="listing_height">
              <CardHeader className="p-0 w-100">
                <div className="read-aloud-header w-100">
                  {/* Filters on left side. */}
                  <div className="header-col-1">
                    <div className="header-col-content">
                      <CardTitle tag="h4">{title}</CardTitle>
                      {/* type filters */}
                      <TypeFilters
                        ALL={ALL}
                        MONTHLY_PREDICTIONS={MONTHLY_PREDICTIONS}
                        EXAM_QUESTIONS={EXAM_QUESTIONS}
                        activeTab={activeTab}
                        showData={showData}
                      />
                    </div>

                    {/* search bar filter */}
                    <SearchFilter
                      search={search}
                      handleSearchChange={handleSearchChange}
                      clickSearch={clickSearch}
                    />
                  </div>

                  {/* Filters on right side. */}
                  <div className="header-col-2">
                    <OtherFilters
                      orderby={orderby}
                      complexity={complexity}
                      attempted={attempted}
                      mark={mark}
                      filterByVid={filterByVid}
                      changeFilter={changeFilter}
                      type={parseInt(state.type)}
                      clearFilters={clearFilters}
                    />
                  </div>
                  {/* <Filters
                      ALL={ALL}
                      MONTHLY_PREDICTIONS={MONTHLY_PREDICTIONS}
                      EXAM_QUESTIONS={EXAM_QUESTIONS}
                      showData={showData}
                      activeTab={activeTab}
                      search={search}
                      handleSearchChange={handleSearchChange}
                      clickSearch={clickSearch}
                      type={parseInt(state.type)}
                      filterByVid={filterByVid}
                      searchByExplanationVideo={searchByExplanationVideo}
                    /> */}
                </div>
              </CardHeader>
              <CardBody>
                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="all"
                    role="tabpanel"
                    aria-labelledby="all-tab"
                  >
                    <div className="table-responsive">
                      {state.isLoading ? (
                        <Spinner />
                      ) : state.data.length === 0 ? (
                        <EmptyData />
                      ) : (
                        <ListTable
                          data={state.data}
                          type={parseInt(state.type)}
                          activeTab={activeTab}
                          mark={mark}
                          attempted={attempted}
                          complexity={complexity}
                          filterByVid={filterByVid}
                          search={search}
                          page={page}
                          listing={state.count}
                          onRendered={() => setTableRendered(true)}
                          testType={"0"}
                        />
                      )}
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="monthlyprediction"
                    role="tabpanel"
                    aria-labelledby="monthlyprediction-tab"
                  >
                    Monthly Prediction table
                  </div>
                  <div
                    className="tab-pane fade"
                    id="examquestions"
                    role="tabpanel"
                    aria-labelledby="examquestions-tab"
                  >
                    Exam Question Table
                  </div>
                </div>

                {/* Pagination */}
                {/* <QuestionListPagination
                  total={state.total}
                  listing={state.displaying_items}
                  updateListingItems={updateListingItems}
                  page={page}
                  paginationChange={paginationChange}
                /> */}

                {tableRendered && (
                  <QuestionListPagination
                    total={state.total}
                    listing={state.count}
                    updateListingItems={updateListingItems}
                    page={page}
                    paginationChange={paginationChange}
                  />
                )}
              </CardBody>
            </Card>
          </div>
        </div>
      )}
    </>
  );
};

export default QuestionList;
